import { render, staticRenderFns } from "./logoFoot.vue?vue&type=template&id=3f45847a&scoped=true&"
import script from "./logoFoot.vue?vue&type=script&lang=js&"
export * from "./logoFoot.vue?vue&type=script&lang=js&"
import style0 from "./logoFoot.vue?vue&type=style&index=0&id=3f45847a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45847a",
  null
  
)

export default component.exports